import React from 'react'
import { X } from 'react-feather'
import { PopupCore } from './core'

const PopupBasic = ({
  title = 'Add Location',
  onClose,
  children
}) => {
  const handleClose = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    if(typeof onClose === 'function'){
      onClose(false)
    }
  }

  return (
    <PopupCore onClose={handleClose}>
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-lg lg:text-3xl text-left font-bold font-primary">
          {title}
        </h1>
        <X className="cursor-pointer" onClick={handleClose}/>
      </div>

      <hr className="mb-5 lg:mb-10"/>

      {children}
    </PopupCore>
  )
}

export { PopupBasic }
